document.addEventListener('DOMContentLoaded', function () {
  var QUOTE_TEXT = /request\s*(a\s*)?quote/i;

  function isQuoteLink(el) {
    if (!el || el.tagName !== 'A') return false;
    var text = (el.textContent || '').trim();
    if (QUOTE_TEXT.test(text)) return true;
    if (el.classList.contains('tcb-quote') || el.classList.contains('tcb-footer__quote-btn') || el.classList.contains('tcb-header__quote-btn')) {
      return true;
    }
    return false;
  }

  function repairQuoteHref(href) {
    if (!href) return href;
    var raw = href;
    var decoded = raw;
    try {
      while (/%25[0-9a-f]{2}/i.test(decoded) || decoded.indexOf('%2Fpages%2Fcontact') > -1) {
        var next = decodeURIComponent(decoded);
        if (next === decoded) break;
        decoded = next;
      }
    } catch (e) {
      decoded = raw;
    }

    if (decoded.indexOf('/pages/contact') > -1) {
      return decoded.charAt(0) === '/' ? decoded : decoded.slice(decoded.indexOf('/pages/contact'));
    }

    if (/\/products\/(%2F|%252F)/i.test(raw) || /%2Fpages%2Fcontact/i.test(raw) || /%252Fpages%252Fcontact/i.test(raw)) {
      try {
        var broken = new URL(raw, window.location.origin);
        var tail = decodeURIComponent(broken.pathname.replace(/^\/products\//, ''));
        if (tail.indexOf('/pages/contact') === 0) {
          return tail + broken.search + broken.hash;
        }
      } catch (e2) {
        return href;
      }
    }

    return href;
  }

  function normalizeQuoteHref(href) {
    href = repairQuoteHref(href);
    if (!href || href.indexOf('/pages/contact') === -1) return href;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return '/pages/contact?topic=quote#tcb-contact-form';
      if (window.TcbSecurity && !window.TcbSecurity.isSafeContactPath(url.pathname + url.search + url.hash)) {
        return '/pages/contact?topic=quote#tcb-contact-form';
      }
      if (!url.searchParams.get('topic')) {
        url.searchParams.set('topic', 'quote');
      }
      if (!url.hash) {
        url.hash = 'tcb-contact-form';
      }
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  document.querySelectorAll('a[href]').forEach(function (link) {
    if (!isQuoteLink(link)) return;
    var normalized = normalizeQuoteHref(link.getAttribute('href'));
    if (normalized && normalized !== link.getAttribute('href')) {
      link.setAttribute('href', normalized);
    }
  });

  var rfqSlot = document.getElementById('tcb-rfq-app-slot');
  if (rfqSlot && !rfqSlot.querySelector('a.tcb-quote, button.tcb-quote, .sb-rfq-button, .cfp-button')) {
    var productTitle = document.querySelector('.tcb-buy-box h1')?.textContent?.trim();
    var href = normalizeQuoteHref('/pages/contact?topic=quote' + (productTitle ? '&product=' + encodeURIComponent(productTitle) : '') + '#tcb-contact-form');
    var fallback = document.createElement('a');
    fallback.className = 'tcb-quote tcb-primary-rfq';
    fallback.href = href;
    fallback.textContent = 'Request a Quote';
    rfqSlot.appendChild(fallback);
  }
});
